module.exports = __webpack_public_path__ + "static/media/M-Cure T5.bcf33219.jpg";